<template>
  <div class="nav-tab-menu container">
    <div
      class="menu-icon"
      @mouseover="showAllMenu"
    >
      <i class="h-icon-menu"></i>
    </div>
    <el-tabs
      :value="activeTabMenu"
      type="card"
      class="u-nav-tab"
      @tab-remove="handleMenuRemove"
      @tab-click="handleMenuClick"
    >
      <el-tab-pane
        v-for="menu in tabMenus"
        :key="menu.menuId"
        :name="menu.menuId"
        :class="{ unclose: !menu._closeable }"
        :closable="menu._closeable && menu.menuId !== 'home'"
      >
        <template slot="label">
          <div class="triangle triangle-l"></div>
          <span
            class="content"
            :title="menu.name"
          >{{ menu.name }}</span>
          <div class="triangle triangle-r"></div>
        </template>
      </el-tab-pane>
    </el-tabs>
    <i
      class="h-icon-refresh u-refresh"
      @click="handleRefresh"
      v-if="activeTab!=='home'"
    ></i>
    <el-dropdown
      class="tab-operator"
      @command="handleCommand"
      @visible-change="_coverVideo('tabOperator')"
      v-show="tabMenus.length > 1"
    >
      <div class="dropdown-inner">
        <i class="h-icon-more_verti"></i>
      </div>
      <el-dropdown-menu
        id="tabOperator"
        name="tabOperator"
        slot="dropdown"
      >
        <iframe
          style="position:absolute;left:0;top:0;width:100%;height:100%;z-index:-1;"
          frameborder="0"
        ></iframe>
        <el-dropdown-item
          command="close-left"
          class="dropdown-item"
        >{{ $t("indexPage.close_tab_left") }}
        </el-dropdown-item>
        <el-dropdown-item
          command="close-right"
          class="dropdown-item"
        >{{ $t("indexPage.close_tab_right") }}
        </el-dropdown-item>
        <el-dropdown-item
          command="close-other"
          class="dropdown-item"
        >{{ $t("indexPage.close_tab_other") }}
        </el-dropdown-item>
        <el-dropdown-item
          command="close-all"
          class="dropdown-item"
        >{{
          $t("indexPage.close_tab_all")
          }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { CoverVideo } from 'utils/mixin'
export default {
  name: 'nav-tab-menu',
  data () {
    return {
      activeTab: 'home'
    }
  },
  computed: {
    ...mapGetters(['tabMenus', 'activeTabMenu'])
  },
  mixins: [CoverVideo],
  methods: {
    // 刷新当前tab
    handleRefresh () {
      let activeTab = this.$storage.session.get(`portal-active-tab-menu-${this.$store.state.userName}`)
      if (activeTab && activeTab !== 'home') {
        let iframe = document.getElementById(`iframe${activeTab}`)
        iframe && iframe.contentWindow.location.reload(true)
      }
    },
    handleMenuRemove (tab) {
      let iframeWrap = document.getElementById(`iframeWrap${tab}`)
      let iframe = document.getElementById(`iframe${tab}`)
      if (iframe) {
        let _iframe = iframe.contentWindow
        iframe.src = 'about:blank'
        try {
          _iframe.document.write('')
          _iframe.document.clear()
        } catch (e) {
          console.log(e)
        }
        iframeWrap.removeChild(iframe)
      }
      this.removeTabMenu({
        menuId: tab
      })
    },
    handleMenuClick (tab) {
      const _menu = this.tabMenus.filter(item => item.menuId === tab.name)
      let params = {
        menuId: tab.name,
        componentMenuId: _menu[0].componentMenuId,
        permissionCode: _menu[0].permissionCode
      }
      this.setActiveTabMenu(params)
    },
    showAllMenu () {
      this.$emit('show-all-menu')
    },
    handleCommand (command) {
      if (command === 'close-left') {
        this.closeActiveLeft()
      } else if (command === 'close-right') {
        this.closeActiveRight()
      } else if (command === 'close-other') {
        this.closeActiveOther()
      } else {
        this.closeAll()
      }
    },
    ...mapMutations({
      setActiveTabMenu: 'SET_ACTIVE_TAB_MENU'
    }),
    ...mapActions([
      'removeTabMenu',
      'closeActiveLeft',
      'closeActiveRight',
      'closeActiveOther',
      'closeAll'
    ]),
    _setActiveMenu () {
      let activeMenuId = this.$storage.session.get(`portal-active-tab-menu-${this.$store.state.userName}`) || ''
      let openTabs = this.$storage.session.get(`portal-tab-menus-${this.$store.state.userName}`) || []
      let activeMenu = null
      if (openTabs && openTabs.length > 0) {
        openTabs.forEach(tab => {
          if (activeMenuId === tab.menuId) {
            activeMenu = tab
          }
        })
      }
      if (activeMenu) {
        let params = {
          menuId: activeMenu.menuId,
          componentMenuId: activeMenu.componentMenuId || null,
          permissionCode: activeMenu.permissionCode || null
        }
        this.setActiveTabMenu(params)
      }
    },
    findMenu (arr, value, key) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i][key] === value) {
          return arr[i]
        }
        if (arr[i]._hasChild || (arr[i].children && arr[i].children.length > 0)) {
          let _res = this.findMenu(arr[i].children, value, key)
          if (_res) return _res
        }
      }
      return null
    }
  },
  watch: {
    activeTabMenu (value) {
      this._setActiveMenu()
      this.activeTab = this.$storage.session.get(`portal-active-tab-menu-${this.$store.state.userName}`)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../style/hui-reset";

.nav-tab-menu.container {
  box-sizing: border-box;
  padding-left: 50px;
  padding-right: 40px;
  position: relative;
  height: 32px;
  ::v-deep .h-icon-close {
    color: #fff;
    z-index: 999;
  }
  .menu-icon {
    height: 32px;
    width: 32px;
    position: absolute;
    left: 4px;
    top: 0;
    cursor: pointer;
    i {
      color: #fff;
      font-size: 24px;
      text-align: center;
      line-height: 32px;
    }
  }
  .tab-operator {
    position: absolute;
    right: 4px;
    top: 0;
    .dropdown-inner {
      display: block;
      box-sizing: border-box;
      cursor: pointer;
      padding-top: 4px;
      font-size: 24px;
      color: #fff;
    }
  }
  ::v-deep .u-nav-tab {
    margin-right:12px;
    .el-tabs__header {
      border: none;
    }
    .el-tabs__nav {
      border: none !important;
    }
    .el-tabs__item {
      color: #fff;
      min-width: 180px;
      height: 32px;
      border: none;
      .el-button {
        float: right;
        min-width: 18px;
        max-width: 18px;
        margin-top: 4px;
        .h-icon-close {
          width: 18px;
          font-size: 18px;
          &::before {
            transform: scale(1);
          }
        }
        &:hover {
          background: transparent;
        }
      }
      .triangle {
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        top: 0;
        border-top: none;
        border-bottom: 32px solid hsla(0, 0%, 100%, 0.08);
      }
      .triangle-l {
        border-left: 12px solid transparent;
        border-right: none;
        left: -1px;
        z-index: 1;
      }
      .triangle-r {
        border-right: 12px solid transparent;
        border-left: none;
        right: -1px;
        z-index: 1;
      }
      .content {
        position: absolute;
        top: 0;
        left: 11px;
        right: 11px;
        background-color: hsla(0, 0%, 100%, 0.08);
        text-align: left;
        box-sizing: border-box;
        padding-left: 12px;
        padding-right: 24px;
        height: 32px;
        font-size: 14px;
        line-height: 32px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &:hover {
        color: #fff;
        .content {
          background-color: hsla(0, 0%, 100%, 0.2);
        }
        .triangle {
          border-bottom: 32px solid hsla(0, 0%, 100%, 0.2);
        }
      }
    }
    .el-tabs__item.is-active {
      border: none;
      color: #fff;
      .content {
        background-color: hsla(0, 0%, 100%, 0.2);
      }
      .triangle {
        border-bottom: 32px solid hsla(0, 0%, 100%, 0.2);
      }
    }
    .el-tabs__nav-next,
    .el-tabs__nav-prev {
      .el-button {
        color: rgba(255, 255, 255, 0.8);
        top: -2px;
        &:hover {
          color: rgba(255, 255, 255, 1);
          background: transparent;
        }
      }
    }
  }
  .u-refresh {
    position: absolute;
    right: 32px;
    top: 5px;
    font-size: 24px;
    color: rgba(255, 255, 255, 0.8);
    display: block;
    cursor: pointer;
    &:hover {
      color: rgba(255, 255, 255, 1);
    }
    &:active {
      color: rgba(255, 255, 255, 0.9);
    }
  }
}
</style>
